/**
 * Updates the data attributes of a product tile based on the provided active data.
 *
 * @param {HTMLElement} container - The container element that holds the product tile.
 * @param {Object} activeData - An object containing key-value pairs to set as data attributes.
 */
export function changeActiveDataDataParams(container, activeData) {
    // update active data attributes
    // Take all data attributes from productTile
    const dataAttributes = Array.from(container.attributes).filter(attr => attr.name.startsWith('data-product-ad-'));

    // Clear all data attributes by mask data-product-ad
    dataAttributes.forEach(attr => container.removeAttribute(attr.name));

    if (activeData) {
        Object.entries(activeData).forEach(([key, value]) => {
            container.setAttribute(`data-product-ad-${key}`, value);
        });
    }
}
